module.exports = __webpack_public_path__ + "img/facebook-white.5e06354c.svg";